import { Row, Col, Card, Table, Button, Modal, Form, Input, Tag, Upload as UploadAntd, Image, DatePicker, Spin, Select, Radio } from "antd";
import InvoiceDetailsFields, { invoiceDetailsInitial, invoiceDetailsPayload } from "../components/InvoiceDetailsFields";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import moment from "moment";
import apiPath from "../constants/apiPath";
import { ExclamationCircleOutlined, FilterFilled } from "@ant-design/icons";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import SingleImageUpload from "../components/SingleImageUpload";
import { DownloadExcel } from "../components/ExcelFile";

const { RangePicker } = DatePicker;

const Search = Input.Search;
let baseURL = apiPath.customerManager;

function MasterFacilitator({ dashbord = false }) {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({}); useState(false);
  const [file, setFile] = useState([]);
  const [mfList, setMfList] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [assignToMf, setAssignToMf] = useState([]);
  const [deleteStep, setDeleteStep] = useState(1);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


  const columns = [
    {
      title: "Profile Image",
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => {
        // console.log(image, "Image");

        if (!image) {
          return (
            <div className="main-new-class-image-no">
              <img src={Noimage} />
            </div>
          );
        }

        return (
          <Image
            src={image}
            alt="Profile"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "5px",
              objectFit: "cover",
            }}
          />
        );
      },
    },
    {
      title: "Name",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Balance Credits",
      dataIndex: "free_credits",
      key: "free_credits",
      render: (_, { free_credits }) => {
        if (!free_credits || free_credits.length === 0) {
          return <span>-</span>;
        }

        return (
          <div>
            {free_credits.map((credit) => (
              <Tag color="blue" key={credit._id}>
                {credit.type}: {credit.quantity}
              </Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: "STATUS",
      key: "isActive",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "InActive",
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      // filtered: true,
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (_, { is_deleted, isActive, _id }) => {
        let color = is_deleted ? "red" : isActive ? "green" : "red";
        return (
          <Tag
            onClick={dashbord ? undefined : (e) => (!is_deleted ? showConfirm(_id) : null)}
            style={dashbord ? { cursor: 'default' } : undefined}
            color={color}
            key={isActive}
          >
            {is_deleted ? "DELETED" : isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
    {
      title: "Registration date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: !dashbord && "Action",
      render: (_, record) => {
        return (
          !dashbord && (
            <>
              <div className="cta_wrap">
                <Button
                  title="Edit"
                  onClick={() => {
                    record?.logo && setFile([record.logo]);
                    setSelected(record);
                    setVisible(true);
                  }}
                >
                  <i class="fa fa-light fa-pen"></i>
                </Button>

                <Button
                  style={{ marginLeft: 8 }}
                  title="Download Certificate"
                  onClick={() => {
                    const url = record?.certifications;
                    if (!url) {
                      return ShowToast(
                        "Please upload valid certificate!",
                        "error"
                      );
                    }
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = url?.split("/").pop();
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  <i className="fa fa-download"></i>
                </Button>
                <Button
                  style={{ marginLeft: 8 }}
                  title="Visit MF Panel"
                  onClick={() => {
                    request({
                      url: apiPath.impersonate,
                      method: "POST",
                      data: { email: record?.email, type: "master_facilitator" },
                      onSuccess: (data) => {
                        const token = data.token;
                        const mfPanelUrl = `https://master.teamintelligencehub.com/dashboard?token=${token}`;
                        // const mfPanelUrl = `http://45.194.47.66:5363/dashboard?token=${token}`;
                        window.open(mfPanelUrl, "_blank");
                      },
                      onError: (error) => {
                        console.error("Error generating token:", error);
                        ShowToast(
                          error?.response?.data?.message ||
                          "Something went wrong while generating token",
                          Severty.ERROR
                        );
                      },
                    });
                  }}
                >
                  <i className="fa fa-eye"></i>
                </Button>
                <Button
                  danger
                  style={{ marginLeft: 8 }}
                  title="Delete"
                  onClick={() => {
                    setDeleteTarget(record);
                    setAssignToMf([]);
                    setDeleteStep(1);
                    setDeleteModalVisible(true);
                  }}
                >
                  <i className="fa fa-trash"></i>
                </Button>


                {/* {permissionObject.edit && (
                    <Button
                      title="Reset Password"
                      onClick={() => {
                        setSelected(record);
                        setProvideSession(true);
                      }}
                    >
                      <i class="fa fa-key" title="Change Password"></i>
                    </Button>
                  )} */}

                {/* <Button
                title="View Listings"
                onClick={(e) => {
                  navigate("/view-user-list/" + record._id);
                  // setViewData(record);
                }}
              >
                <i class="fas fa-list"></i>
              </Button> */}
              </div>
            </>
          )
        );
      },
    },
  ];

  const uploadFileToS3 = async (file) => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, "realState/admin");
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      data: {
        assignToMfIds: assignToMf,
      },
      onSuccess: (data) => {
        // console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);

        setSuccessMessage(data?.message || "Deleted successfully");
        setSuccessModalVisible(true);

        setDeleteModalVisible(false);
        setDeleteStep(1);
        setAssignToMf([]);
        setDeleteTarget(null);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    request({
      url: "admin/certified-practitioner/mf-list",
      method: "GET",
      onSuccess: (data) => {
        setMfList(data?.data?.data);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  }, []);

  useEffect(() => {
    // console.log(dashbord, "dashbord");
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-customer/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    const limit = dashbord ? 10 : pagination ? pagination.pageSize : 10;
    request({
      url: `${baseURL}/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1
        }&limit=${limit}&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: dashbord ? 10 : data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        setLoading(false);
        console.log(error);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={!dashbord && "Master Facilitators"}
              extra={
                !dashbord && (
                  <>
                    <Search
                      size="large"
                      placeholder="Search by Name, Email, Number"
                      onChange={onSearch}
                      title="Search by Name, Email, Number"
                      value={searchText}
                      onPressEnter={onSearch}
                    />

                    <RangePicker onChange={handleChangeDate} />

                    <Button
                      onClick={() => {
                        request({
                          url: `${baseURL}/export`,
                          method: "GET",
                          onSuccess: (data) => DownloadExcel(data.data.list, "Master_Facilitators"),
                          onError: (err) => ShowToast(err?.response?.data?.message, Severty.ERROR),
                        });
                      }}
                    >
                      Export Excel
                    </Button>

                    <Button
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      Add Master Facilitator
                    </Button>
                  </>
                )
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={
                    dashbord
                      ? false
                      : {
                        current: pagination?.current,
                        defaultPageSize: 10,
                        responsive: true,
                        total: pagination.total,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ["10", "20", "30", "50"],
                      }
                  }
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddForm
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>

      <Modal
        open={deleteModalVisible}
        title={
          deleteStep === 1
            ? "Assign Certified Practitioners"
            : "Confirm Permanent Deletion"
        }
        okText={deleteStep === 1 ? "Proceed" : "Delete"}
        cancelText="Cancel"
        okButtonProps={{
          danger: deleteStep === 2,
          disabled: deleteStep === 1 && assignToMf.length === 0,
        }}
        onCancel={() => {
          setDeleteModalVisible(false);
          setDeleteStep(1);
          setAssignToMf([]);
          setDeleteTarget(null);
        }}
        onOk={() => {
          if (deleteStep === 1) {
            setDeleteStep(2);
          } else {
            deleteAccount(deleteTarget);
            setDeleteModalVisible(false);
            setDeleteStep(1);
            setAssignToMf([]);
            setDeleteTarget(null);
          }
        }}
      >
        {deleteStep === 1 && (
          <>
            <p style={{ marginBottom: 12 }}>
              Before deleting{" "}
              <b>{deleteTarget?.name || deleteTarget?.userName}</b>, assign all
              associated Certified Practitioners to one or more Master
              Facilitators.
            </p>

            <Select
              mode="multiple"
              placeholder="Select Master Facilitators"
              allowClear
              showSearch
              value={assignToMf}
              style={{ width: "100%" }}
              className="full-w-select"
              onChange={(value) => setAssignToMf(value)}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children
                  ?.toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {mfList
                ?.filter(
                  (mf) => mf.isActive && mf._id !== deleteTarget?._id
                )
                .map((mf) => (
                  <Select.Option key={mf._id} value={mf._id}>
                    {mf.name || mf.userName}
                  </Select.Option>
                ))}
            </Select>
          </>
        )}

        {deleteStep === 2 && (
          <div style={{ color: "#d32029", fontWeight: 500 }}>
            <p>
              ⚠️ This action will permanently delete{" "}
              <b>{deleteTarget?.name || deleteTarget?.userName}</b>.
            </p>
            <p>This action cannot be undone.</p>
          </div>
        )}
      </Modal>

      <Modal
        open={successModalVisible}
        title="Success"
        onOk={() => setSuccessModalVisible(false)}
        onCancel={() => setSuccessModalVisible(false)}
        okText="OK"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <p>{successMessage}</p>
      </Modal>

    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [logo, setLogo] = useState(null);
  const [signature, setSignature] = useState(null);
  const [certificate, setCertificate] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfLoading, setPdfLoading] = useState(true);
  const [certModalVisible, setCertModalVisible] = useState(false);
  const [certForm] = Form.useForm();
  const [certFile, setCertFile] = useState(null);
  const [certLoading, setCertLoading] = useState(false);

  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp", "application/pdf",];
  const SignatureFileType = ["image/png", "image/jpg", "image/jpeg", "application/pdf",];

  const handleImage = (data) => {
    if (!data || !data[0]) {
      setLogo(null);
      form.setFieldValue("logo", "");
      return;
    }
    const fileData = data[0];
    const normalized = {
      uid: fileData.uid,
      name: fileData.name,
      status: fileData.status,
      url: fileData.url || fileData.Location || fileData,
    };
    setLogo(normalized);
    form.setFieldValue("logo", normalized.url);
  };

  const handleSignature = (data) => {
    if (!data || !data[0]) {
      setSignature(null);
      form.setFieldValue("signature", "");
      return;
    }
    setSignature(data?.[0] || null);
    form.setFieldValue("signature", data?.[0]?.url || "");
  };

  const handleCertificate = (data) => {
    if (!data || !data[0]) {
      setCertificate(null);
      form.setFieldValue("certificate", "");
      return;
    }
    setCertificate(data?.[0] || null);
    form.setFieldValue("certificate", data?.[0]?.url || "");
  };

  // Populate form for edit
  useEffect(() => {
    // if (data) {
    //   form.setFieldsValue({
    //     ...data,
    //     logo: data?.logo?.url || data?.logo,
    //     signature: data?.signature?.url || data?.signature,
    //     certificate: data?.certifications?.url || data?.certifications,
    //   });
    //   setLogo(data?.logo || null);
    //   setSignature(data?.signature || null);
    //   setCertificate(data?.certifications || null);
    // }
    if (data) {
      const normalizeFile = (file) => {
        if (!file) return null;
        return typeof file === "string"
          ? { url: file, status: "done" }
          : { ...file, url: file.url || file.Location || file };
      };

      setLogo(normalizeFile(data.logo));
      setSignature(normalizeFile(data.signature));
      setCertificate(normalizeFile(data.certifications));

      form.setFieldsValue({
        ...data,
        logo: normalizeFile(data.logo)?.url || "",
        signature: normalizeFile(data.signature)?.url || "",
        certificate: normalizeFile(data.certifications)?.url || "",
        ...invoiceDetailsInitial(data),
      });
    }
  }, [data]);

  const onCreate = (values) => {
    // console.log(logo, "image");
    const payload = {
      name: values.name,
      ar_name: values.ar_name,
      email: values.email,
      logo: logo?.url || logo || "",
      signature: signature?.url || signature || "",
      certificate: certificate?.url || certificate || "",
      brandManager: values.brandManager,
      brandStrategist: values.brandStrategist,
      free_credits: values.free_credits,
      ...(data ? invoiceDetailsPayload(values) : {}),
      ...(data && values.report_credits_to_add
        ? { report_credits_to_add: Number(values.report_credits_to_add) }
        : {}),
      ...(data && values.certificate_credits_to_add
        ? { certificate_credits_to_add: Number(values.certificate_credits_to_add) }
        : {}),
      ...(data && values.credits_to_add
        ? {
            credits_to_add: Number(values.credits_to_add),
            credit_type: values.credit_type || "report",
          }
        : {}),
    };

    setLoading(true);
    request({
      url: data ? `${baseURL}/edit-user/${data._id}` : `${baseURL}/add`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast(
          (data
            ? "MASTER FACILITATOR UPDATED"
            : "NEW MASTER FACILITATOR ADDED") || res.message,
          Severty.SUCCESS
        );

        hide();
        refresh();
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err.response.data.message, Severty.ERROR);
      },
    });
  };

  return (
    <>
      <Modal
        open={show}
        onCancel={hide}
        width={800}
        title={data ? "Edit Master Facilitator" : "Add Master Facilitator"}
        okButtonProps={{ form: "add-mf-form", htmlType: "submit", loading }}
      >
        <div style={{ textAlign: "right", marginBottom: 12 }}>
          <Button onClick={() => { certForm.resetFields(); setCertFile(null); setCertModalVisible(true); }}>Add Certificate</Button>
        </div>
        <Form id="add-mf-form" layout="vertical" form={form} onFinish={onCreate}>
          <Row gutter={16}>
            {/* Full Name */}
            <Col span={24} md={12}>
              <Form.Item
                label="Full Name of Master Facilitator"
                name="name"
                normalize={(val) => val.trimStart()}
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.reject("Name is required");
                      }
                      if (value.trim() === "") {
                        return Promise.reject("Name cannot be only spaces");
                      }
                      return Promise.resolve();
                    },
                  },
                  {
                    pattern: /^[\p{L}\p{M}\s\-]+$/u,
                    message:
                      "Only letters, diacritics, spaces, and hyphen (-) are allowed (e.g. JEAN-FRANCOIS)",
                  },
                  {
                    max: 50,
                    message: "Name cannot exceed 60 characters",
                  },
                ]}
              >
                <Input placeholder="Enter Master Facilitator Name" />
              </Form.Item>
            </Col>

            {/* Email */}
            <Col span={24} md={12}>
              <Form.Item
                label="Email Address"
                name="email"
                normalize={(val) => val.trimStart()}
                rules={[
                  { required: true, message: "Please enter an email address" },
                  {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                    message: "Please enter a valid email address",
                  },
                  { max: 100, message: "Email should not exceed 100 characters" },
                ]}
              >
                <Input placeholder="Enter email" />
              </Form.Item>
            </Col>

            {/* Free Credits */}

            {/* {!data && (
            <Col span={24} md={12}>
              <Form.Item
                label="Number of Free Credits"
                name="free_credits"
                rules={[
                  {
                    required: true,
                    message: "Please enter number of free credits",
                  },
                  {
                    pattern: /^\d+$/,
                    message: "Free credits must be a number",
                  },
                ]}
              >
                <Input placeholder="Enter number of free credits" />
              </Form.Item>
            </Col>
          )} */}

            {/* Give Credits - only in edit mode */}
            {data && (
              <>
                <Col span={24} md={12}>
                  <Form.Item
                    label="Report Credits to Add"
                    name="report_credits_to_add"
                    rules={[
                      {
                        pattern: /^-?\d+$/,
                        message: "Credits must be a whole number",
                      },
                    ]}
                  >
                    <Input placeholder="Enter report credits to add" type="number" />
                  </Form.Item>
                </Col>
                <Col span={24} md={12}>
                  <Form.Item
                    label="Certificate Credits to Add"
                    name="certificate_credits_to_add"
                    rules={[
                      {
                        pattern: /^-?\d+$/,
                        message: "Credits must be a whole number",
                      },
                    ]}
                  >
                    <Input placeholder="Enter certificate credits to add" type="number" />
                  </Form.Item>
                </Col>
              </>
            )}

            {/* Signature */}
            <Col span={24} md={12}>
              <Form.Item
                label="Signature (PNG, JPEG, PDF)"
                name="signature"
              // You can uncomment validation if needed
              // rules={[
              //   {
              //     validator: (_, value) => {
              //       if (value && value.type === "image/jpeg") {
              //         return Promise.resolve();
              //       } else {
              //         return Promise.reject(new Error("Signature must be a JPEG image"));
              //       }
              //     },
              //   },
              // ]}
              >
                <SingleImageUpload
                  value={signature}
                  fileType={SignatureFileType}
                  imageType={"Signature"}
                  btnName={"Signature"}
                  onChange={(data) => handleSignature(data)}
                  isDimension={false}
                />
              </Form.Item>
              {console.log(signature, "signature here check easy --->")}

              {signature && (
                <div className="mt-2 add-img-product mb-4">
                  {signature?.url?.toLowerCase().endsWith(".pdf") ? (
                    <div
                      onClick={() =>
                        window.open(
                          signature?.url + "?response-content-disposition=inline",
                          "_blank"
                        )
                      }
                      style={{
                        cursor: "pointer",
                        width: 120,
                        height: 120,
                        background: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #d9d9d9",
                      }}
                    >
                      <span>PDF Preview</span>
                    </div>
                  ) : (
                    <Image
                      width={120}
                      src={signature.url?.url || signature?.url || signature}
                    />
                  )}
                </div>
              )}
            </Col>

            {/* Certificate */}
            <Col span={24} md={12}>
              <Form.Item
                label="Certificate (PNG, JPEG, PDF)"
                name="certificate"
              // You can uncomment validation if needed
              // rules={[
              //   {
              //     validator: (_, value) => {
              //       if (value && value.type === "image/jpeg") {
              //         return Promise.resolve();
              //       } else {
              //         return Promise.reject(new Error("Signature must be a JPEG image"));
              //       }
              //     },
              //   },
              // ]}
              >
                <SingleImageUpload
                  value={certificate}
                  fileType={FileType}
                  imageType={"Ceritificate"}
                  btnName={"Ceritificate"}
                  onChange={(data) => handleCertificate(data)}
                  isDimension={false}
                />
              </Form.Item>

              {certificate && (
                <div className="mt-2 add-img-product mb-4">
                  {String(
                    certificate?.url || certificate
                  ).toLowerCase().endsWith(".pdf") ? (
                    <div
                      onClick={() => {
                        const url =
                          certificate?.url?.url ||
                          certificate?.url ||
                          certificate;

                        setPdfUrl(url);
                        setPdfLoading(true);
                        setIsPdfModalOpen(true);
                      }}
                      style={{
                        cursor: "pointer",
                        width: 120,
                        height: 120,
                        background: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #d9d9d9",
                      }}
                    >
                      <span>PDF Preview</span>
                    </div>
                  ) : (
                    <Image
                      width={120}
                      src={certificate?.url?.url || certificate?.url || certificate}
                    />
                  )}
                </div>
              )}
            </Col>

            {/* Logo Upload */}
            <Col span={24} md={12}>
              <Form.Item
                label="Logo (To be printed on Certificate) (PNG, JPEG, PDF)"
                name="logo"
                rules={[
                  {
                    validator: (_, value) => {
                      if (data && !logo) {
                        // In edit mode, if logo was deleted, no validation required
                        return Promise.resolve();
                      }
                      if (value !== undefined && value?.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "Please upload a logo in .png, .jpeg, .jpg, or .pdf format (max 5 MB)"
                        )
                      );
                    },
                  },
                ]}
              >
                <SingleImageUpload
                  value={logo}
                  fileType={FileType}
                  imageType={"Profile"}
                  btnName={"Logo"}
                  onChange={(data) => handleImage(data)}
                  isDimension={false}
                />
              </Form.Item>

              <p className="img-size-details">
                ** Accepted formats: <b>.png</b>, <b>.jpeg</b>, <b>.jpg</b>,{" "}
                <b>.pdf</b> — Maximum size: <b>5 MB</b> **
              </p>

              {logo && (
                <div className="mt-2 add-img-product mb-4">
                  {logo?.url?.toLowerCase().endsWith(".pdf") ? (
                    <div
                      onClick={() =>
                        window.open(
                          logo?.url + "?response-content-disposition=inline",
                          "_blank"
                        )
                      }
                      style={{
                        cursor: "pointer",
                        width: 120,
                        height: 120,
                        background: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #d9d9d9",
                      }}
                    >
                      <span>PDF Preview</span>
                    </div>
                  ) : (
                    <Image width={120} src={logo.url?.url || logo?.url || logo} />
                  )}
                </div>
              )}
            </Col>

            {data && (
              <Col span={24}>
                <InvoiceDetailsFields />
              </Col>
            )}
          </Row>
        </Form>


      </Modal>

      <Modal
        open={isPdfModalOpen}
        onCancel={() => setIsPdfModalOpen(false)}
        footer={null}
        width={900}
        title="Certificate Preview"
        destroyOnClose
      >
        <Spin spinning={pdfLoading} tip="Loading PDF...">
          <iframe
            src={`https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true`}
            width="100%"
            height="700px"
            onLoad={() => setPdfLoading(false)}
            style={{
              visibility: pdfLoading ? "hidden" : "visible",
            }}
          />
        </Spin>
      </Modal>

      <Modal
        open={certModalVisible}
        title="Add Certificate"
        onCancel={() => setCertModalVisible(false)}
        okText="Upload"
        confirmLoading={certLoading}
        onOk={() => certForm.submit()}
      >
        <Form
          form={certForm}
          layout="vertical"
          onFinish={(values) => {
            if (!certFile) {
              ShowToast("Please upload a certificate file", Severty.ERROR);
              return;
            }
            setCertLoading(true);
            request({
              url: `${baseURL}/add-certificate/${data._id}`,
              method: "POST",
              data: { fileUrl: certFile, serial_number: values.serial_number },
              onSuccess: () => {
                ShowToast("Certificate added successfully", Severty.SUCCESS);
                setCertModalVisible(false);
                setCertLoading(false);
                refresh();
              },
              onError: (err) => {
                ShowToast(err?.response?.data?.message || "Failed to add certificate", Severty.ERROR);
                setCertLoading(false);
              },
            });
          }}
        >
          <Form.Item label="Serial Number (optional)" name="serial_number">
            <Input placeholder="Enter serial number" type="number" min={1} />
          </Form.Item>
          <Form.Item label="Certificate File (PNG, JPEG, PDF)">
            <SingleImageUpload
              value={certFile ? { url: certFile, status: "done" } : null}
              fileType={["image/png", "image/jpg", "image/jpeg", "application/pdf"]}
              imageType="Certificate"
              btnName="Certificate"
              onChange={(d) => setCertFile(d?.[0]?.url || null)}
              isDimension={false}
            />
          </Form.Item>
          {certFile && (
            <div className="mt-2 add-img-product mb-4">
              {String(certFile).toLowerCase().endsWith(".pdf") ? (
                <div
                  onClick={() => window.open(certFile + "?response-content-disposition=inline", "_blank")}
                  style={{ cursor: "pointer", width: 120, height: 120, background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #d9d9d9" }}
                >
                  <span>PDF Preview</span>
                </div>
              ) : (
                <Image width={120} src={certFile} alt="Certificate" />
              )}
            </div>
          )}
        </Form>
      </Modal>

    </>
  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        // console.log(error.response.data, "Error")
        setLoading(false);
        ShowToast(error.response.data.message, Severty.ERROR);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
                },
                {
                  max: 100,
                  message: "Title cannot exceed 100 characters",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default MasterFacilitator;
